export default __webpack_public_path__ + "static/media/credit-card.c05cdbc1.svg";